import React from 'react';
import { Icon } from './icons';
import { useYoutubeChannel } from '../utils/useYoutubeChannel';

// Home CTA under the intro video. Hidden unless a channel URL is saved and toggled on.
export default function YoutubeChannelButton() {
  const { url, enabled } = useYoutubeChannel();
  if (!enabled) return null;
  return (
    <div style={{ marginTop: 20 }}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-outline"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 20px' }}
      >
        <Icon name="PlayCircle" size={18} /> 유튜브 채널 바로가기
      </a>
    </div>
  );
}
